import flatten from 'flat'
import { loadScript } from './load-script'
import * as config from '../config'

export interface GetSourceEmbedderOptions<TSettings> {
  version?: string
  baseUrl?: string
  file?: string
  settings?: TSettings
  globalName: string
}

/**
 * Load an embedder script into the page and return it
 *
 * @param opts
 */
export async function loadEmbedder<TReturn, TSettings> (opts: GetSourceEmbedderOptions<TSettings>): Promise<TReturn> {
  const url = getEmbedUrlFromSettings(opts)
  const globalName = opts.globalName

  return await loadScript({
    url: url.toString(),
    globalName,
    reuseGlobal: true,
    resolveGlobal: true
  })
}

/**
 * Generate a URL based on the provided options. If settings
 * are provided, they are flattened to their json.object.path
 * with dot notation and appended to the search params
 *
 * @param opts
 */
export function getEmbedUrlFromSettings<TSettings> (opts: GetSourceEmbedderOptions<TSettings>): URL {
  const {
    version = config.DEFAULT_EMBED_SCRIPT_VERSION,
    baseUrl = config.DEFAULT_EMBED_SCRIPT_URL,
    file = config.DEFAULT_EMBED_SCRIPT_NAME,
    settings
  } = opts

  const url = new URL(`${baseUrl}${version}/${file}`)

  // if no settings, then return early
  if (settings == null) return url

  // otherwise flatten the settings and add to the URL
  const flattened: Record<string, any> = flatten(settings)
  Object.entries(flattened).forEach(([key, val]) => {
    url.searchParams.set(key, val)
  })

  return url
}
